import { Dispatch, createContext, useContext } from 'react'

import { LoginModalProps } from '@web/components/layout/LoginModal'

import { BiddingModalProps } from '../BiddingModal/BiddingModal.types'
import type { RegisterModalProps } from '../RegisterModal/RegisterModal'

export const modalsInitialState: NoModalState = {
  modal: null,
  props: null,
}

export const ModalsContext = createContext<{
  modalState: ModalState
  dispatch: Dispatch<ModalAction> | null
}>({ modalState: modalsInitialState, dispatch: null })

export const useModals = () => {
  return useContext(ModalsContext)
}

export function modalsReducer(
  state: ModalState,
  action: ModalAction
): ModalState {
  switch (action.type) {
    case 'CLOSE':
      return modalsInitialState
    case 'OPEN':
      return action.payload
  }
}

export type NoModalState = { modal: null; props: null }
export type RegisterModalState = {
  modal: 'REGISTER_NOW'
  props: Omit<RegisterModalProps, 'setIsOpen'>
}
export type LoginModalState = {
  modal: 'LOGIN'
  props: Omit<LoginModalProps, 'setIsOpen' | 'defaultScreen'>
}
export type CreateAccountModalState = {
  modal: 'CREATE_ACCOUNT'
  props: Omit<LoginModalProps, 'setIsOpen' | 'defaultScreen'>
}
export type ResetPasswordCompleteModalState = {
  modal: 'RESET_PASSWORD_COMPLETE'
  props: Omit<LoginModalProps, 'setIsOpen' | 'defaultScreen'>
}
export type ResetPasswordModalState = {
  modal: 'RESET_PASSWORD'
  props: Omit<LoginModalProps, 'setIsOpen' | 'defaultScreen'>
}
export type BiddingModalState = {
  modal: 'BID_NOW'
  props: Omit<BiddingModalProps, 'setIsOpen'>
}

export type ModalState =
  | NoModalState
  | RegisterModalState
  | LoginModalState
  | CreateAccountModalState
  | ResetPasswordCompleteModalState
  | ResetPasswordModalState
  | BiddingModalState

export type ModalAction = OpenModalAction | CloseModalAction

export type OpenModalAction = {
  type: 'OPEN'
  payload:
    | RegisterModalState
    | LoginModalState
    | CreateAccountModalState
    | ResetPasswordCompleteModalState
    | ResetPasswordModalState
    | BiddingModalState
}

export type CloseModalAction = {
  type: 'CLOSE'
  payload: NoModalState | undefined
}
